
import Range from 'vux/src/components/range/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'

import headerBackTitle from '@/components/header/headerBackTitleShare'
import Progress from '@/crowd_fund/Progress'
import zcHelprecord from '@/crowd_fund/zcHelprecord'
import zcfooter from '@/crowd_fund/zcfooter'
import { setTimeout } from 'timers';
import Carousel from '@/components/swiper/carousel.vue'
import CarouselBig from '@/components/swiper/carouselBig.vue'

const list = () => ['项目详情', '项目进展', '爱心动态']
let Base64 = require('js-base64').Base64
export default {
components:{
headerBackTitle,
Range,
Flexbox,
Tab,
TabItem,
Progress,
zcHelprecord,
zcfooter,
'v-swiper':Carousel,
'v-swiperBig':CarouselBig
},
data () {
return {
subsidyAmount:'',
cmsid:'',
videoFM:true,
borderColor: {
borderColor: '#fff'
},
initiator:'',//发起机构，
initiatorTwo:'',//发起机构，
beneficiary:'',//接收善款，
exploitingUnit:'',//组织实施单位
list2:list(),
index:0,
proge:2,
acr001:this.$route.params.id,
details:'',
showPdfS:true,
successNum:0,  //白内障帮扶成功数
successNum1:0,  //白内障帮扶成功数
spotN:0,      //点赞次数
imgArr:[],   //相册图片
videoSrc:'',   //视频
proPreg:['执行进展','项目案例'],
protype:1,
jinzhanlength:0,  //进展数
anlilength:0,   //案例数
checkStatus:[],  //查看全文标识
imgIndex:0,     //图片放大
imgBigTar:false,    //图片放大框
imageurlArr:[],     //放大图片
newsInfo:[],        //新闻
jxQuery:[],
infoquery:[],
supporlist:[],
sortIndex:0,
sjmon:1,
infototal:'',
supporlisttotal:0,
zcuserid:'',
zctoken:'',
zcnickname:'',
histroy:false,
bangfu:false,
shareInfo:{},     //app分享信息
contentStyleObj:{
height:''
},
isPublish: '',
listTotal:0,
threeList:[],
companyList:[],
epId: '',
isFirst:false,
dtId:'',//一起捐项目Id
isQualification: false,
isBindFlag: '',
isBindShow:'',
isPayShow:false,
PayShow:'',
tipFlag:false,

anlpba:false,	//安卓未登录捐款返回时处理
zc_header:false,
zc_img_url: this.appjump_url+'/img/userLoGo.png',
zc_go_ewm: this.appjump_url+'/page/index_gz.html',


ActChannel_strs: '',

jzImgisHide: [],
MoreJzImage:[],
arrow_up_grey: require('../assets/images/arrow_up_grey.png'),
arrow_down_grey: require('../assets/images/arrow-down_grey.png')
}
},
methods:{
videoPlay(){
this.videoFM = false;
let video = document.getElementById("video_play");
video.play();
},
getAnlpbaFlag(){	//安卓跳转证书
if(!this.isWeixinCient()){


var ua = window.navigator.userAgent;
var isTxNews = window.navigator.userAgent.match(/qqnews\/([\.\d]+)/i);
var isYlxd = /ulxdapp/.test(navigator.userAgent.toLowerCase());
var isSunland = ua.match(/sunland/i);

var isLiePinAndroid = (ua.indexOf('Android') > -1 || ua.indexOf('Adr') > -1) && ua.indexOf('android-tongdao-app') > -1;
var isLiePinIos = !!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) && ua.indexOf('ios-tongdao-app') > -1;
var isLiePin = isLiePinAndroid || isLiePinIos;

if((isTxNews&&isTxNews[1])||isYlxd||isSunland||isLiePin){
var a = this.G('anlpbaFlag');
if(a=='1'){
this.apbaGoCertrain()
}else if (a=='2'){//证书返回

this.anlpba = false;
}
}else if (/(Android)/i.test(navigator.userAgent)) {
var a = this.G('anlpbaFlag');
if(a=='1'){	//支付后

var b = this.G('queryZcToken')

if(b == '(null)' || b == undefined || b == '' || b == null || b == 'null'){
this.anlpba = true;
this.L('anlpbaFlag','2')
}else{	//已登录

this.apbaGoCertrain()
}
}else if (a=='2'){//证书返回

this.anlpba = false;
}
}
}
},
apbaGoCertrain(){
this.L('anlpbaFlag','2')
this.anlpba=false;
this.$router.push('/zccertificateTrain/'+this.G('queryAcr002')+'/'+this.G('queryTimeNow')+'/'+this.G('queryId')+'/'+this.G('queryZcUserid')+'/'+this.G('queryZcToken')+'/'+this.G('queryNickname')+'/'+this.G('querySubmitMoney')+'/'+this.G('queryFoundation')+'/'+this.G('queryOrderno')+(this.$route.query.ActCode?('?ActCode='+this.$route.query.ActCode):'?ActCode=')+(this.$route.query.channelCode?('&channelCode='+this.$route.query.channelCode):''))

},
anlpbaGoLogin(){
this.L('anlpbaFlag','2')
this.anlpba=false;

var u = navigator.userAgent
let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); 
if(isiOS){
window.webkit.messageHandlers.AppReturnToLoginPage.postMessage('callNative')
}else{
javascript: android.AppReturnToLoginPage('callNative')
}
},
cueNewHeaderImg(){
var imgA = this.G('zcheadimgurl');
var imgB = this.$route.query.headImage;
if(imgB=='null'||imgB==null||imgB==undefined||imgB=='(null)'||imgB=='undefined'||imgB == imgA){
return
}else{
this.L('zcheadimgurl',imgB);
}
},
cancelTip() {
if(this.isQualification){
this.isQualification = false
}
if(this.isBindShow){
this.isBindShow = false
}
},
PayTip() {
this.isPayShow = false
},
backRequest(bool){
this.isPayShow = bool
},
toBind() {
this.$router.push('/bindMobile/'+this.acr001)
},
staffRankLink(orgName,epId) {
this.$router.push('/dTRankStaff/'+orgName+'/'+this.acr001+'_'+epId+'/'+epId+'/'+this.acr001)
},
goRank() {
this.$router.push('/dTRankCompany/'+this.acr001)
},
dtLink() {
if(this.isWeixinCient()) {

if(this.isPublish) {

if (this.isFirst) {

if(!this.tipFlag){

if(this.details.acr018 ==5){
this.showToast('','text','项目执行中,不能发起一起捐','20em','','')
}else if(this.details.acr018 ==6){
this.showToast('','text','项目已结束,不能发起一起捐','20em','','')
}else{
this.$router.push('/dTEdit/'+this.acr001+'/'+this.epId)
}
}else{
this.showToast('','text','该企业已被平台禁用,不能发起一起捐','20em','','')
}
} else {
this.L("zcuserid",this.zcuserid)
this.L("zctoken",this.zctoken)
this.L('zcnickname',this.zcnickname)
this.$router.push('/dTDetail/'+this.dtId+'/'+this.acr001+'/'+this.epId+'/false')
}
}else {

if(this.isBindFlag) {

this.isBindShow = true
}else{
this.isQualification = true

}
}
}else {


let token = this.$route.params.zctoken || 1111
if(token == '(null)' || token == undefined || token == '' || token == null || token == 'null'){

var u = navigator.userAgent
let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); 
if(isiOS){
window.webkit.messageHandlers.AppReturnToLoginPage.postMessage('callNative')
}else{
javascript: android.AppReturnToLoginPage('callNative')
}
}else {
if(this.isPublish) {

if (this.isFirst) {

if(!this.tipFlag){
if(this.details.acr018 ==5){
this.showToast('','text','项目执行中,不能发起一起捐','20em','','')
}else if(this.details.acr018 ==6){
this.showToast('','text','项目已结束,不能发起一起捐','20em','','')
}else{
this.$router.push('/dTEdit/'+this.acr001+'/'+this.epId)
}
}else{
this.showToast('','text','该企业已被平台禁用,不能发起一起捐','20em','','')
}
} else {
this.$router.push('/dTDetail/'+this.dtId+'/'+this.acr001+'/'+this.epId+'/details')
}
}else {

this.isQualification = true
}
}
}
},
isFirstPublish() {
let data={
crowdfundingId: this.acr001,
creatorId: this.epId
}
this.$https.post(this.BASE_URL+"grd/groupDonation/ongoing",
data
)
.then(res => {
if(res.data.code == "GRD-APII0000") {
this.isFirst = false
this.dtId = res.data.data
}else {
this.isFirst = true
}
})
.catch(function(err) {

})
},
isCompany() {
let data={
userId: this.G("zcuserid")

}
this.$https.post(this.BASE_URL+"grd/groupDonation/isAuthorized",
data
)
.then(res => {

if(res.data.code == "GRDI0000") {
this.isPublish = true
this.epId = res.data.data
this.isFirstPublish()
}else if(res.data.code == "GRD06004"){
this.isPublish = true
this.epId = res.data.data
this.tipFlag = true
this.isFirstPublish()
}else{
this.isPublish = false
}
})
.catch(function(err) {

})
},
isBindPhone() {
let self = this;
this.$jsonp(this.wechat_url+'ssoredis/login/l003/getWebToken',{
'unionid':this.G("zcunionid")
}).then( data => {


if(data.statusCode == 200 && data.result.resCode == '000') {
this.isBindFlag = true
}else if(data.statusCode == 200 && data.result.resCode == '-1'){
this.showToast('','text','未授权，无法进行绑定','20em','','')
} else {
this.isBindFlag = false
}
})
},
isAuthorization() {

window.location.href = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" + this.wechatAppid + "&redirect_uri=" + encodeURIComponent( this.appjump_url + "/pages/index/#/zcprojectDetail/" + this.acr001 + "/null/null/null?isShare=share"+this.ActChannel_strs)+"&scope=snsapi_userinfo&response_type=code&state=wxh5267689457315#wechat_redirect"
},
getHeight(){

this.contentStyleObj.height=window.innerHeight-90+'px';
},
bangfuishow() {
if(this.bangfu == false){
this.bangfu = true
}else{
this.bangfu = false
}
},
toThousands(nStr) {
nStr += '';
let x = nStr.split('.');
let x1 = x[0];
let x2 = x.length > 1 ? '.' + x[1] : '';
var rgx = /(\d+)(\d{3})/;
while (rgx.test(x1)) {
x1 = x1.replace(rgx, '$1' + ',' + '$2');
}
return x1 + x2;
},
replaceStr:function(content){
var reg = /习近平班底|中国末代接班群第六代|江泽民|茉莉花革命|习近平|操纵十八大|毛泽东|中共九十年功罪|政权保卫战|枪|法轮功|赖昌星|邓小平|信用卡套现|轻松筹|水滴筹|腾讯公益|爱心筹|骗子|水滴互助|小姐|卖淫/g;
var showC = content.replace(reg,function( $reg ){
var r = '';
for ( var i=0;i<$reg.length;i++ )
{
r += '*';
}
return r;
})
return showC;
},
goQKL (data) {
if(this.isWeixinCient()){
window.location.href=this.QKL_URL+data
}else{

window.navigation.pushPage('{"title":"扶贫区块链","url":"'+this.QKL_URL+data+'&platform=app","navbarHidden":"YES"}')
}
},
getRankCompany() {
let data={
crowdfundingId: this.acr001
}
this.$https.post(this.BASE_URL+"grd/groupDonation/listOfGroupDonationByCFID",
data,
)
.then(res => {
if(res.data.code == "GRDI0000") {
this.listTotal = res.data.data.total;

this.threeList.push(...res.data.data.data.slice(0,3))
}
})
.catch(function(err) {

})
},
getImgList(strImg){
let a=[]
if(strImg){
a=strImg.split(',')
}

return a
},
MoreJzImg(index){
var MoreJzImgIndex = !this.jzImgisHide[index];
if(MoreJzImgIndex==false){
this.$set(this.MoreJzImage,index,'更多图片');
}else{
this.$set(this.MoreJzImage,index,'收起图片');
}
this.$set(this.jzImgisHide,index,MoreJzImgIndex);
},
goOrg(org_user_id){
this.$router.push('/zcorganDetails/'+org_user_id+'/'+this.$route.params.id+'/'+this.$route.params.zcuserid+'/'+this.zcnickname+'/'+this.$route.params.zctoken)
},
childbyvalue (value) {
this.sjmon = value;
this.sortIndex = 0;
this.getsuuporlist();
},
refresh (done) {
this.sortIndex = 0
this.getsuuporlist(done);
},
infinite (done) {
this.sortIndex++
this.getsuuporlist(done);
},
getMchTypeById () {
let data={
crowdfundingId: this.acr001
}
this.$https.post(this.BASE_URL+"grd/mchTypeForCfs/getMchTypeById",
data,
)
.then(res => {
if(res.data.code=="GRDI0000"){
this.PayShow = res.data.data.mchType;
}else{
this.PayShow = '';
}
})
.catch(function(err) {

})
},
getDetail () {
let data={
acr001: this.acr001
}
this.$https.post(this.BASE_URL+"cfs/zc/project/getLoadxmxx",
data,
)
.then(res => {
this.details = res.data.data;
this.wechatshareneedkey(); 
this.videoSrc = res.data.data.videoUploadUrl;

this.imgArr = res.data.data.batchImages.split(',');
})
.catch(function(err) {

})
this.$https.get(this.BASE_URL+'tas/dp/gyData',{params:{
}}).then( data => {
console.log(data.data,'data.data.qz.subsidyAmountdata.data.qz.subsidyAmount');
this.subsidyAmount=(data.data.data.qz.subsidyAmount/10000).toFixed(2)
})
},
findvideocover(url) {
let _this = this;
this.$nextTick(() => {
let video = document.getElementById("video_play");
video.play();



});
},
getThreeInfo(){
let data={
acr001: this.acr001
}
this.$https.post(this.BASE_URL+"cfs/zc/project/getThreeInfo",
data,
)
.then(res => {
let data = res.data.data;
if(res.data.code=='CFSI0000'){

this.initiator = data.initiator;
let initiatorAll = data.initiator.split('、')
if(initiatorAll.length == 1){
this.initiator = initiatorAll[0];
}else{
this.initiator = initiatorAll[0];
this.initiatorTwo = initiatorAll[1];
}
this.beneficiary = data.beneficiary;
this.exploitingUnit = data.exploitingUnit;
}
})
.catch(function(err) {

})

},
getProScheInfoQuery () {
let data={
acr001: this.acr001
}
this.$https.post(this.BASE_URL+"cfs/ajaxpagequery/zc/z005/proScheInfoQuery",
this.qs.stringify(data),
{
headers: {
'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
}
}
)
.then(res => {
this.infoquery = res.data.result.pageresult.data;
this.infototal = res.data.result.pageresult.total;
for(var i=0;i<this.infoquery.length;i++){
if(this.infoquery[i].protype == 2){
this.anlilength = this.anlilength +1;
}
if(this.infoquery[i].protype == 1){
this.jinzhanlength = this.jinzhanlength + 1;
}
this.jzImgisHide.push(false);
this.MoreJzImage.push('更多图片');
var obj = {
index:i,
checkStatus:false
}
this.checkStatus.push(obj)
}
})
.catch(function(err) {

})
},
getproConcRptQuery(){

var data = {
acr001:this.acr001
}
this.$https.post(this.BASE_URL+"/cfs/ajaxquery/zc/z005/proConcRptQuery",
this.qs.stringify(data),{
headers: {
'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
}
}).then(res =>{

this.jxQuery=res.data.result.data
if(this.jxQuery>1){
this.jxQuery=this.jxQuery.splice(0,1)
}

}).catch(err => {

})
},
showPdf(e){

if(e==1){
this.showPdfS = false;
}else{
this.showPdfS = true;
}
},
wechatshareneedkey  () {
if(this.isWeixinCient()){
let lineLink=window.location.href.split('#')[0];
this.shareInfo = {
title : this.details.title || '中国社会帮扶网',
desc: this.details.acr013,
link : this.appjump_url+'/pages/index/#/zcprojectDetail/'+this.$route.params.id+'/null/null/null'+"?isShare=share"+this.ActChannel_strs,
imgUrl: this.details.acr065
};
this.L('zcPayBack_ShareInfo',JSON.stringify(this.shareInfo));
this.setWeixinConfig(this.shareInfo);
}else{

this.shareInfo = '{"picurl":"'+this.details.acr065+'","title":"'+this.details.title+'","type":"'+2+'","projectId":"'+this.$route.params.id+'","text":"'+this.details.acr013+'","url":"'+this.appjump_url+'/pages/index/#/zcprojectDetail/'+this.$route.params.id+'/null/null/null?isShare=share'+this.ActChannel_strs+'","ischange":'+'"2"}'

this.L('zcPayBack_ShareInfo',JSON.stringify(this.shareInfo));
}
},
getsuuporlist (done,has) {
let data={
acr001: this.acr001,
pageIndex:this.sortIndex,
pageSize:8,
sjmon:this.sjmon
}
this.$https.post(this.BASE_URL+"cfs/zc/z005/supportlist",
this.qs.stringify(data),
{
headers: {
'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
}
}
)
.then(res => {
if(this.sortIndex == 0){
this.supporlist = res.data.result.pageresult.data
this.supporlisttotal = res.data.result.pageresult.total
}else{
for(let i=0;i<res.data.result.pageresult.data.length;i++){
this.supporlist.push(res.data.result.pageresult.data[i])
}
}
if(!res.data.result.pageresult.data.length){
if(done){
done(true)
}
return
}
if(done){
done(true)
}

})
.catch(function(err) {

})
},
getUrlParamURLysas(name) {
var reg = new RegExp("(^|&)"+ name +"=([^&]*)(&|$)");
var r = window.location.search.substr(1).match(reg);
if (r != null){
return unescape(r[2]);
}
return "";
},
wxchat () {
let self = this;
this.$https.get(this.BASE_URL+'uts/invitationCode/wxAuthorization',{params:{
'code':this.getUrlParamURLysas("code")
}}).then( data => {
let res = data.data
if(res.code == 'UTSI0000') {
self.zcuserid = res.data.userId;
self.zctoken = res.data.logintoken;
self.zcnickname = res.data.nickname

localStorage.setItem('zcuserid',res.data.userId);
localStorage.setItem('zcopenid',res.data.openid);
localStorage.setItem('zcunionid',res.data.unionid);
localStorage.setItem('zcnickname',res.data.nickname);
localStorage.setItem('zcheadimgurl',res.data.headimgurl);
localStorage.setItem('zctoken',self.zctoken);
this.isCompany()
this.isBindPhone()
}else{
this.isCompany();
this.isBindPhone()
}
})
},

drawMain(drawing_elem, percent, forecolor, bgcolor) {
/*
@drawing_elem: 绘制对象
@percent：绘制圆环百分比, 范围[0, 100]
@forecolor: 绘制圆环的前景色，颜色代码
@bgcolor: 绘制圆环的背景色，颜色代码
*/
var context = drawing_elem.getContext("2d");
var center_x = drawing_elem.width / 2;
var center_y = drawing_elem.height / 2;
var rad = Math.PI*2/100;
var speed = 0;

function backgroundCircle(){
context.save();
context.beginPath();
context.lineWidth = 10; 
var radius = center_x - context.lineWidth;
context.lineCap = "round";
context.strokeStyle = bgcolor;
context.arc(center_x, center_y, radius, 0, Math.PI*2, false);
context.stroke();
context.closePath();
context.restore();
}

function foregroundCircle(n){
context.save();
context.strokeStyle = forecolor;
context.lineWidth = 10;
context.lineCap = "round";
var radius = center_x - context.lineWidth;
context.beginPath();
context.arc(center_x, center_y, radius , -Math.PI/2, -Math.PI/2 +n*rad, false); 
context.stroke();
context.closePath();
context.restore();
}

function text(n){
context.save(); 
context.fillStyle = forecolor;
var font_size = 16;
context.font = font_size + "px Helvetica";
var text_width = context.measureText(n.toFixed(2)+"%").width;
context.fillText(n.toFixed(2)+"%", center_x-text_width/2, center_y + font_size/8);
context.restore();
}

(function drawFrame(){
window.requestAnimationFrame(drawFrame);
context.clearRect(0, 0, drawing_elem.width, drawing_elem.height);
backgroundCircle();
if(percent == 0 || percent == null){
text(0);
}else if(percent>100){
text(100);
foregroundCircle(speed);
if(speed >= percent) return;
if(speed >=100) return;
speed += 1;
}
else{
text(percent);
foregroundCircle(speed);
if(speed >= percent) return;
if(speed >=100) return;
speed += 1;
}
}());
},

cureNumber(){









this.$https.get(this.BASE_URL+'/cfsqz/projectPublicity/selectTreatmentCount')
.then(res=>{
console.log(res)
this.successNum = res.data.data
})
},

cureNumber1(){














this.$https.get(this.BASE_URL+'/tas/dp/gyData')
.then(res=>{
console.log(res,'11111')
this.successNum1 = res.data.data.bnz.caseNum
})
},

spotNum() {
var data = {
acr001:this.acr001
}
this.$https.post(this.BASE_URL+"cfs/zc/project/updateFabulous",data).then(
response => {

this.spotN = response.data.data.fabulous;
}
).catch(err => {

})
},

go_ewm(){
let self = this;

_czc.push(﻿['_trackEvent','众筹头部关注','点击','二维码',1])
setTimeout(function(){
window.location.href= self.zc_go_ewm;
},500)
}
,proTypeNo(e){
this.sjmon = e+1;
this.protype = e+1;
},
ifFollow(){
let self = this;
this.$jsonp(this.wechat_url+"shfpwebwx/wechatAuth/getIsAttention",{
'openid':localStorage.getItem('zcopenid')
}).then( data => {
if(data.result.subscribe=="0"){//未关注
if(this.$route.query.isShare == "share"){//分享出去的
if(this.isWeixinCient()){

self.zc_header = true;
}
}
}
})
}
,changeStatus(ind){       //查看全文/收起

this.checkStatus[ind].checkStatus = !this.checkStatus[ind].checkStatus;

}
,changeBig(e,k){      //查看大图

this.imgIndex = k;
this.imageurlArr = e;
this.imgBigTar = true;
}
,closeBig(){         //关闭大图
this.imgBigTar = false;
},
getNewsList(cmsid){      //新闻列表

var data = {
"txnBodyCom": {
"column_code":cmsid,
"handleWay":"0"
},
"txnCommCom": {
"tRecInPage": 20,
"tPageJump": 1,

}
}
this.$https.get(this.CCY_URL+'/ccy/advert/fp/fsx11004?column_code='+cmsid+'&handleWay=0&current=1&size=20').then(res => {
console.log(res)

if(res.data.code==0){
this.newsInfo = res.data.data.records
console.log(this.newsInfo);
if(this.newsInfo.length>1){
this.newsInfo = this.newsInfo.splice(0,1);
}
}
}
).catch(err => {

})













},








































goNewsDet(e){      //新闻详情

let linkUrl = location.protocol+'//'+location.host+'/gzddpt/index.html#/cmsDetail?id='+e.news_id
console.log(linkUrl)






window.location.href = linkUrl
},
goNewsList(){    //新闻列表
this.$router.push({path:'/zcnewsList',query:{newsId:this.cmsid}})
}
},
mounted (){




window.ReturnUser = (users)=>{
console.log(window.location.href)

let a=JSON.parse(users)

console.log(users)
console.log(a)

let location_hash = window.location.href.split('?')[1]

location_hash = location.hash.indexOf('user_type')>-1?this.changeURLPar(location_hash,'user_type',a.user_type):location_hash

let location_url = ''
if(a.token){
if(a.user_type == 20){
location_url = process.env.APPJUMP_URL+'/pages/index/?#/zcprojectDetail/'+this.acr001+'/null/'+encodeURIComponent(a.nickname)+'/'+a.token+'?'+location_hash
}else{
location_url = process.env.APPJUMP_URL+'/pages/index/?#/zcprojectDetail/'+this.acr001+'/'+a.fpUserId+'/'+encodeURIComponent(a.nickname)+'/'+a.token+'?'+location_hash
}
console.log(location_url)

window.location.replace(location_url)
}
}


this.getAnlpbaFlag();
this.getHeight()
if(this.$route.query.histroy){
this.histroy=true
}
this.zcuserid = this.$route.params.zcuserid
this.zctoken = this.$route.params.zctoken
this.zcnickname = decodeURIComponent(this.$route.params.zcnickname)
this.getDetail();
this.getThreeInfo();
this.getMchTypeById();
this.getproConcRptQuery();
this.getProScheInfoQuery();
this.cureNumber();
this.cureNumber1();
this.getsuuporlist();
this.getRankCompany();
if(this.acr001 == 5001){

this.getNewsList('pth-xgxw');
this.cmsid = 'pth-xgxw';
}else if(this.acr001 == 5021){

this.getNewsList('bnz-xgxw');
this.cmsid = 'bnz-xgxw';
}else if(this.acr001 == 5301){

this.getNewsList('qzzt-xgxw');
this.cmsid = 'qzzt-xgxw';
}


},
updated(){
var time_canvas = document.getElementById("time-graph-canvas");
var time_num = Number(this.$refs.itCanvas.innerHTML)

this.drawMain(time_canvas,time_num, "rgb(243,115,6)", "#e1e1e1");
},
created() {
console.log(window.location.href,'这是列表的地址众筹详情');
this.ActChannel_strs = (this.$route.query.channelCode?('&channelCode='+this.$route.query.channelCode):'')+(this.$route.query.ActCode?('&ActCode='+this.$route.query.ActCode):'');
if(this.isWeixinCient()) {
if(this.$route.query.isShare == "share") {
if(this.getUrlParamURLysas("code") == null || this.getUrlParamURLysas("code") ==''){

this.isAuthorization()

this.isCompany();
this.isBindPhone();

}else {
this.wxchat()
}
this.ifFollow();
}else{

this.isCompany();
this.isBindPhone()
}

}else {

this.L("zcuserid",this.$route.params.zcuserid)
this.L("zctoken",this.$route.params.zctoken)
this.L("zcnickname",this.$route.params.zcnickname)
this.zctoken = this.$route.params.zctoken
this.cueNewHeaderImg()
this.isCompany();
}
},
beforeRouteLeave (to, from , next) {
if(to.name == 'zcprojectList'){
sessionStorage.setItem("isFromDetail",true)
}
next()
}
}



// WEBPACK FOOTER //
// ./src/crowd_fund/projectDetail.vue